import styled from 'styled-components';

import colors from 'themes/Main';

const { gray03, gray06 } = colors;

export const Divider = styled.p`
  position: relative;
  display: block;
  width: 100%;
  margin: ${({ hasTopSpacing }) =>
    hasTopSpacing ? '50px 0 40px' : '0 0 40px'};
  font-weight: 700;
  font-size: 14px;
  line-height: 20px;
  color: ${gray03};

  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -4px;
    width: 100%;
    height: 1px;
    background-color: ${gray06};
  }
`;
